import Header from "../components/header";
import PageTitle from "../components/page-title";
import PageNavigator from "../components/page-navigator";
import ScanFeedHolder from "../components/scan-feed-holder";
import Holder from "../components/holder";
import InputModule from "../components/input-module";
import { useState,useEffect } from "react";
import { fetchVoices } from "../functions/fetchVoices";
import { deleteUrl } from "../functions/deleteUrl";
import { openSiteAdder } from "../functions/openInput";
import { getAuthCode } from "../functions/getAuthCode";
import CustomPostModule from "../components/custom-post-module";
import { openCustomPostModule } from "../functions/openCustomPostModule";


function ScanPage(){
    const [inputOpen,setInputOpen] = useState(false);
    const [voices,setVoices] = useState(null)

    const handleClick = () => {
        openSiteAdder(setInputOpen,inputOpen);
    }
        const [customPostModuleOpen,setCustomPostModuleOpen] = useState(false);

    const handleClick2 = () =>{
        openCustomPostModule(setCustomPostModuleOpen,customPostModuleOpen)
    }


    const [loggedUrls, changeLoggedUrls] = useState([]);
    const [fullyLoaded, changeFullyLoaded] = useState(false);    
    useEffect(() => {
      const fetchData = async () => {
        fetchVoices(setVoices);
        try {
          const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/retrieveinputs", {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({auth_code:await getAuthCode()}),
          });
          const result = await response.json();
          changeLoggedUrls(result);
          changeFullyLoaded(true);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }, []);

    const handleDeleteClick = (url) => {
        console.log(url);
        deleteUrl(changeLoggedUrls,url);
    }

    return <>
    <Header CTA='Add site' functionForButton={handleClick} CTA2="Create post" functionForButton2={handleClick2}></Header>
    <Holder 
    left={<PageNavigator numberSelected={3}/>}
    right={<>
    <PageTitle text='Manage the sites you want Mako to crawl for intel.' heading='Your scanned sites'></PageTitle>
    <ScanFeedHolder openSiteAdder={handleClick} isLoaded={fullyLoaded} handleClick={handleDeleteClick} feedItems={loggedUrls} context='scan'/></>}
    />
    <InputModule functionForButton={handleClick} display={inputOpen ? 'flex' : 'none'}/>
    <CustomPostModule loadedVoices={voices} display={customPostModuleOpen ? 'flex' : 'none'} functionForButton={handleClick2} />
    </>
}
    
export default ScanPage;